<div style="text-align: center; background-color: #f8f9fa; padding: 20px; border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);">
  <img src="https://img.icons8.com/ios/50/000000/construction-worker.png" alt="Ícone de Construção" style="width: 80px; height: 80px; margin-bottom: 15px;">
  <h2 style="font-size: 24px; color: #333; margin-bottom: 15px;">Rota em Construção</h2>
  <p style="font-size: 16px; color: #666;">Desculpe, esta página está em construção. Por favor, volte mais tarde.</p>
</div>
